import React from 'react';
import styles from './index.css';
import { h5PageCount } from '../../../utils';
import { WxLaunchApp } from '../../wxLaunchApp';
import { wxShareTool } from '../../../utils/wxShareTool';
const { callApp, getSchemeLink, getWebAppLink } = require('@ifeng-fe/callapp');
class CallupHead extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isClose: true,
            keyword: '',
            isShowAppIcon: false,
        };
        this.androidAppIconHandle = () => {
            var _a, _b;
            const UA = navigator.userAgent.toLocaleLowerCase();
            try {
                // @ts-ignore
                if (typeof (window === null || window === void 0 ? void 0 : window._shareTimeUpload) !== 'undefined' && (window === null || window === void 0 ? void 0 : window.BJ_REPORT)) {
                    // @ts-ignore
                    window._shareTimeUpload.callupheaddidmount =
                        typeof performance == 'object' && performance.now ? performance.now() : -1;
                }
            }
            catch (e) {
                console.log(e);
            }
            if (wxShareTool && UA.toLocaleLowerCase().match(/android/) && /micromessenger/i.test(UA)) {
                this.setState({
                    isShowAppIcon: false,
                });
            }
            else {
                this.setState({
                    isShowAppIcon: true,
                });
            }
            (_a = wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.on) === null || _a === void 0 ? void 0 : _a.call(wxShareTool, 'showAppIcon', () => {
                this.setState({
                    isShowAppIcon: true,
                });
            });
            (_b = wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.on) === null || _b === void 0 ? void 0 : _b.call(wxShareTool, 'wxLaunchReady', () => {
                try {
                    // @ts-ignore
                    if (typeof (window === null || window === void 0 ? void 0 : window._shareTimeUpload) !== 'undefined' && (window === null || window === void 0 ? void 0 : window.BJ_REPORT)) {
                        // @ts-ignore
                        window._shareTimeUpload.wxkaifangbiaoqianready =
                            typeof performance == 'object' && performance.now ? performance.now() : -1;
                        // @ts-ignore
                        const _err = new Error(JSON.stringify(window._shareTimeUpload));
                        window.BJ_REPORT && window.BJ_REPORT.report(_err, false, 24);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            });
            setTimeout(() => {
                if (!this.state.isShowAppIcon) {
                    this.setState({
                        isShowAppIcon: true,
                    });
                }
            }, 3000);
        };
        this.handleClick = (url, id, newstype, userId, others, position, downloads, isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            const { topClickInfo, fixClickInfo, isVideoShare, pageInfo } = this.props.content;
            const doc_type = newstype;
            const aid = pageInfo.base62Id || pageInfo.id;
            const userIdVal = userId || '';
            const client = isVideoShare ? 'videoApp' : 'newsApp';
            const crowdid = pageInfo.crowdid || '';
            if (!downloads) {
                if (isVideoShare) {
                    downloads = {
                        download: '',
                        downloadAd: '',
                    };
                }
                else {
                    downloads = {
                        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354726493926',
                        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7639',
                    };
                }
            }
            if (position === 1 && topClickInfo) {
                if (isJumpQQlink) {
                    h5PageCount([
                        {
                            behavior: topClickInfo.behavior || 'action',
                            type: topClickInfo.type || 'upopen',
                            other: {
                                ref: topClickInfo.ref || '',
                                kind: topClickInfo.kind || '',
                                tag: 't9',
                            },
                        },
                    ]);
                }
                if (isSendCount) {
                    h5PageCount([
                        {
                            behavior: topClickInfo.behavior || 'action',
                            type: topClickInfo.type || 'upopen',
                            other: {
                                ref: topClickInfo.ref || '',
                                kind: topClickInfo.kind || '',
                            },
                        },
                    ]);
                }
                if (isCallApp) {
                    callApp({
                        client,
                        docType: doc_type,
                        pid: aid,
                        kind: topClickInfo.callupKind,
                        download: downloads.download,
                        downloadAd: downloads.downloadAd,
                        userId: userIdVal,
                        noKindFrom: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.noKindFrom) || 0,
                        crowdid,
                        isCopySchemeUrl: isJumpQQlink,
                    });
                }
            }
            else if (position === 2) {
                if (isJumpQQlink) {
                    h5PageCount([
                        {
                            behavior: (fixClickInfo && fixClickInfo.behavior) || 'action',
                            type: (fixClickInfo && fixClickInfo.type) || 'grgxfc',
                            other: {
                                ref: (fixClickInfo && fixClickInfo.ref) || '',
                                kind: (fixClickInfo && fixClickInfo.kind) || '',
                                tag: 't9',
                            },
                        },
                    ]);
                }
                if (isSendCount) {
                    h5PageCount([
                        {
                            behavior: (fixClickInfo && fixClickInfo.behavior) || 'action',
                            type: (fixClickInfo && fixClickInfo.type) || 'grgxfc',
                            other: {
                                ref: (fixClickInfo && fixClickInfo.ref) || '',
                                kind: (fixClickInfo && fixClickInfo.kind) || '',
                            },
                        },
                    ]);
                }
                if (isCallApp) {
                    callApp({
                        client,
                        docType: doc_type,
                        pid: aid,
                        kind: (fixClickInfo && fixClickInfo.callupKind) || '',
                        download: downloads && downloads.download,
                        downloadAd: downloads && downloads.downloadAd,
                        noKindFrom: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.noKindFrom) || 0,
                        userId: userIdVal,
                        crowdid,
                        isCopySchemeUrl: isJumpQQlink,
                    });
                }
            }
        };
        this.clickFixedFn = () => {
            this.setState({
                isClose: true,
            });
        };
        this.launchAppSuccess = () => {
            const { sendSucessLog } = this.props.content;
            // 发送成功日志
            if (sendSucessLog === true) {
                try {
                    if (window.BJ_REPORT) {
                        window.BJ_REPORT.report(new Error(), false, 52);
                        console.log('开发标签发送拉起成功日志');
                    }
                }
                catch (err) {
                    console.error(err);
                }
            }
        };
        this.header = React.createRef();
    }
    componentDidMount() {
        const { pageInfo, hotKeyword } = this.props.content;
        this.androidAppIconHandle();
        if (hotKeyword) {
            const keywordStr = hotKeyword[Math.floor(Math.random() * hotKeyword.length)];
            this.setState({
                keyword: keywordStr,
            });
        }
        if (pageInfo) {
            this.isHideFn();
        }
    }
    isHideFn() {
        const headerHeight = (this.header.current && this.header.current.offsetHeight) || 0;
        const srcollBox = document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop);
        let beforeScrollTop = srcollBox || 0;
        let stausDown = true;
        let stausUp = true;
        let isScroll = true;
        let isTop = true;
        window.addEventListener('scroll', () => {
            // if (!isScroll) return false;
            const afterScrollTop = document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop) || 0;
            const delta = afterScrollTop && afterScrollTop - beforeScrollTop;
            if (isTop && ((afterScrollTop && afterScrollTop <= headerHeight) || afterScrollTop === 0)) {
                isTop = false;
                setTimeout(() => {
                    isScroll = true;
                }, 300);
                this.setState({
                    isClose: true,
                });
                return false;
            }
            else if (afterScrollTop && afterScrollTop > headerHeight) {
                isTop = true;
            }
            if (delta === 0 || (afterScrollTop && afterScrollTop <= headerHeight)) {
                return false;
            }
            if (delta && delta > 0 && stausUp) {
                stausDown = true;
                stausUp = false;
                isScroll = false;
                setTimeout(() => {
                    isScroll = true;
                }, 300);
                this.setState({
                    isClose: true,
                });
                // console.log('向下');
            }
            else if (delta && delta < 0 && stausDown) {
                stausUp = true;
                stausDown = false;
                isScroll = false;
                setTimeout(() => {
                    isScroll = true;
                }, 300);
                this.setState({
                    isClose: false,
                });
                // console.log('向上');
            }
            beforeScrollTop = afterScrollTop;
            return false;
        }, false);
    }
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { pageInfo, hotKeyword, isVideoShare, maxWidth, fixClickInfo, topClickInfo, wxLaunchSwitch, wxLaunchType, weappLink, } = this.props.content;
        const { isClose, keyword, isShowAppIcon } = this.state;
        const maxWidthStyle = maxWidth
            ? {
                maxWidth: `${maxWidth}`,
            }
            : {};
        let schemeLink1 = getSchemeLink({
            docType: pageInfo.type || 'awake',
            pid: pageInfo.base62Id || pageInfo.id,
            kind: (topClickInfo && topClickInfo.callupKind) || '',
            userId: pageInfo.userId || '',
            crowdid: pageInfo.crowdid || '',
        });
        let schemeLink2 = getSchemeLink({
            docType: pageInfo.type || 'awake',
            pid: pageInfo.base62Id || pageInfo.id,
            kind: (fixClickInfo && fixClickInfo.callupKind) || '',
            userId: pageInfo.userId || '',
            crowdid: pageInfo.crowdid || '',
        });
        if (wxLaunchType === 'weapp') {
            schemeLink2 = schemeLink1 =
                weappLink ||
                    getWebAppLink({
                        docType: pageInfo.type,
                        pid: pageInfo.base62Id ? pageInfo.base62Id : pageInfo.id,
                    });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("header", { ref: this.header, className: styles.header },
                React.createElement("a", { onClick: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 1, pageInfo.downloads), href: "javascript:;", className: styles.headerBox },
                    React.createElement("span", { className: `${styles.logo} ${isVideoShare && styles.videoLogo}` }),
                    isShowAppIcon && React.createElement("span", { className: styles.botton }, "\u7ACB\u5373\u6253\u5F00"),
                    !isVideoShare && wxLaunchSwitch && (React.createElement(WxLaunchApp, { launchType: wxLaunchType, launchAppClick: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 1, pageInfo.downloads, true, false, false), schemeLink: schemeLink1, launchAppFail: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 1, pageInfo.downloads, false, true, true), launchAppSuccess: this.launchAppSuccess })))),
            hotKeyword && (React.createElement("header", { style: maxWidthStyle, className: !isClose ? styles.headerIn : styles.headerOut },
                React.createElement("a", { onClick: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 2, pageInfo.downloads), href: "javascript:;", className: styles.info },
                    React.createElement("h3", { className: styles.title }, keyword),
                    isShowAppIcon && React.createElement("span", { className: styles.openBtn }, "\u6253\u5F00"),
                    !isVideoShare && wxLaunchSwitch && (React.createElement(WxLaunchApp, { launchType: wxLaunchType, schemeLink: schemeLink2, launchAppClick: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 2, pageInfo.downloads, true, false, false), launchAppFail: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 2, pageInfo.downloads, false, true, true), launchAppSuccess: this.launchAppSuccess }))),
                React.createElement("a", { href: "javascript:;", onClick: this.clickFixedFn, className: styles.close })))));
    }
}
export default CallupHead;
